/** @flow */
const url = require('url');


export default function getURL(stringToParse) {
  return (url.parse(stringToParse));
}

